import React from "react";
import { useTranslation } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import ModalWindow from "components/ModalWindow";
import "./style.scss";

interface Props {
  slotContentConfirmationExit?: JSX.Element;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ModalExitConfirmation({ slotContentConfirmationExit, onCancel, onConfirm }: Props) {
  const { t } = useTranslation();

  return (
    <ModalWindow show onClose={onCancel} className="modal-exit-confirmation">
      <>
        {slotContentConfirmationExit ? (
          slotContentConfirmationExit
        ) : (
          <h1 className="headline-1 text-center">{t("Do you want to end the chat?")}</h1>
        )}
        <div className="modal-exit-confirmation__buttons mt-6">
          <BaseButton large outline onClick={onCancel} className="modal-exit-confirmation__confirm">
            {t("Cancel")}
          </BaseButton>
          <BaseButton name="confirm-exit" large negative onClick={onConfirm} className="stream-view__cancel">
            <BaseIcon className="stream-view__control-icon mr-1">call</BaseIcon>
            {t("End Now")}
          </BaseButton>
        </div>
      </>
    </ModalWindow>
  );
}
